import { Button, Icon, Input, InputProps, Text } from '@chakra-ui/react';
import React, { ForwardedRef, useRef } from 'react';

import { UploadIconOutline } from '../../assets/icons/UploadIconOutline';

type ImageFileUpload = {
  text?: string;
  isLoading?: boolean;
};

type InputControlProps = ImageFileUpload & { inputProps?: InputProps };

// eslint-disable-next-line react/display-name
export const ImageFileUpload: React.FC<InputControlProps> = React.forwardRef(
  (props: InputControlProps, ref: ForwardedRef<HTMLInputElement>) => {
    const { text, inputProps, ...rest } = props;

    const inputRef = useRef<HTMLInputElement | null>(null);

    return (
      <>
        <Button
          w="180px"
          h="149px"
          justify="center"
          align="center"
          whiteSpace="normal"
          flexDir="column"
          borderRadius="32px"
          color="#FF5000"
          bg="#F4F4F4"
          border="solid 1px #FF5000"
          fontSize=".8rem"
          variant="ghost"
          fontWeight="normal"
          _focus={{ outline: 'none' }}
          onClick={() => inputRef.current?.click()}
        >
          <Icon fontSize="1.6rem" as={UploadIconOutline} />
          <Text w="65%">{text}</Text>
        </Button>

        <Input
          accept="image/png, image/jpeg"
          hidden
          ref={inputRef}
          {...inputProps}
          type="file"
          borderColor="orange.500"
        />
      </>
    );
  }
);
